export default __webpack_public_path__ + "static/media/cms-logo.13eedfed.png";